<template>
  <div class="index-swiper-view swiper-view">
    <van-swipe :autoplay="2000">
      <van-swipe-item v-for="item in bannerList" :key="item.id">
        <div class="swiper-banner-wrap">
          <img class="banner-img" :src="item.img_path" />
        </div>
      </van-swipe-item>
    </van-swipe>
    <div class="view-list-wrap">
      <div class="header">
        <span class="text--header">学院推荐</span>
      </div>
      <div class="course-list">
        <CourseItem
          v-for="item in recommCourseList"
          :key="item.id"
          v-bind="item"
        />
      </div>
    </div>

    <div class="view-list-wrap">
      <div class="header">
        <span class="text--header">热门学习</span>
      </div>
      <div class="course-list">
        <CourseItem
          v-for="item in hotCourseList"
          :key="item.id"
          v-bind="item"
        />
      </div>
    </div>


    <div class="view-list-wrap">
      <div class="header">
        <span class="text--header">最新发布</span>
      </div>
      <div class="course-list">
        <CourseItem
          v-for="item in latestCourseList"
          :key="item.id"
          v-bind="item"
        />
      </div>
    </div>

    

  </div>
</template>
<script>
import { Swipe, SwipeItem } from 'vant';
import CourseItem from '../../components/CourseItem';
export default {
  name: 'indexSwiperView',
  components: {
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    CourseItem
  },
  props: [
    'bannerList',
    'newsItemList',
    'latestCourseList',
    'recommCourseList',
    'hotCourseList'
  ]
};
</script>

<style lang="stylus" scoped>
.index-swiper-view {
  .swiper-banner-wrap{
    margin: 30px auto;
    width: 690px;
		height: 273px;
  }

	.news-list {
		padding: 0 15px;
	}

	.tag-list {
		margin: 0 15px;
		padding-top: 23px;
		border-bottom: 2px solid #F1F1F1;

		.tag-item-comp {
			margin: 0 10px 23px;
		}
	}

	.college-list {
		padding: 26px 0;

		.college-item {
			margin-left: 30px;
			width: 330px;
			height: 270px;

			.cover-img {
				display: block;
				height: 194px;
				margin-bottom: 10px;
				border-radius: 16px;
			}

			.title {
				padding: 0 12px;
			}
		}
	}

	.course-list {
		padding: 20px 0 100px 0;

		.course-item-comp {
			margin-left: 30px;
      margin-bottom: 30px;
		}
	}


}
</style>
